export default __webpack_public_path__ + "static/media/fa-regular-400.44c094ee.woff2";